import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    abreviacion: '',
    credito: false,
    requiereNumero: false,
    cuentaId: 0,
    cuenta: null,
    cuentaNombre: null,
    rubroId: 0,
    rubro: null,
    rubroNombre: null,
    subrubroId: 0,
    subrubro: null,
    subrubroNombre: null,
    cuentaIngresosGastosId: 0,
    cuentaIngresosGastos: null,
    cuentaIngresosGastosNombre: null,
    interesBancarioRubroId: 0,
    interesBancarioRubro: null,
    interesBancarioRubroNombre: null,
    gastoBancarioRN: false,
    inversionRN: false,
    restringido: false,
    rowVersion: null,

    bancoMovimientoTipoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_BANCO_MOVIMIENTO_TIPO'(state, bancoMovimientoTipoId) {
        state.id = bancoMovimientoTipoId;
        state.nombre = '';
        state.abreviacion = '';
        state.credito = false;
        state.requiereNumero = false;
        state.cuentaId = 0;
        state.cuenta = null;
        state.cuentaNombre = null;
        state.rubroId = 0;
        state.rubro = null;
        state.rubroNombre = null;
        state.subrubroId = 0;
        state.subrubro = null;
        state.subrubroNombre = null;
        state.cuentaIngresosGastosId = 0;
        state.cuentaIngresosGastos = null;
        state.cuentaIngresosGastosNombre = null;
        state.interesBancarioRubroId = 0;
        state.interesBancarioRubro = null;
        state.interesBancarioRubroNombre = null;
        state.gastoBancarioRN = false;
        state.inversionRN = false;
        state.restringido = false;
        state.rowVersion = null;
    },
    'SET_BANCO_MOVIMIENTO_TIPO'(state, bancoMovimientoTipo) {
        state.nombre = bancoMovimientoTipo.nombre.trim();
        state.abreviacion = bancoMovimientoTipo.abreviacion.trim();
        state.credito = bancoMovimientoTipo.credito;
        state.requiereNumero = bancoMovimientoTipo.requiereNumero;
        state.cuentaId = bancoMovimientoTipo.cuenta? bancoMovimientoTipo.cuenta.id : 0;
        state.cuenta = bancoMovimientoTipo.cuenta;
        state.cuentaNombre = bancoMovimientoTipo.cuenta? bancoMovimientoTipo.cuenta.nombre.trim() : null;
        state.rubroId = bancoMovimientoTipo.rubro? bancoMovimientoTipo.rubro.id : 0;
        state.rubro = bancoMovimientoTipo.rubro;
        state.rubroNombre = bancoMovimientoTipo.rubro? bancoMovimientoTipo.rubro.nombre.trim() : null;
        state.subrubroId = bancoMovimientoTipo.subrubro? bancoMovimientoTipo.subrubro.id : 0;
        state.subrubro = bancoMovimientoTipo.subrubro;
        state.subrubroNombre = bancoMovimientoTipo.subrubro? bancoMovimientoTipo.subrubro.nombre.trim() : null;
        state.cuentaIngresosGastosId = bancoMovimientoTipo.cuentaIngresosGastos? bancoMovimientoTipo.cuentaIngresosGastos.id : 0;
        state.cuentaIngresosGastos = bancoMovimientoTipo.cuentaIngresosGastos;
        state.cuentaIngresosGastosNombre = bancoMovimientoTipo.cuentaIngresosGastos? bancoMovimientoTipo.cuentaIngresosGastos.nombre.trim() : null;
        state.interesBancarioRubroId = bancoMovimientoTipo.interesBancarioRubro? bancoMovimientoTipo.interesBancarioRubro.id : 0;
        state.interesBancarioRubro = bancoMovimientoTipo.interesBancarioRubro;
        state.interesBancarioRubroNombre = bancoMovimientoTipo.interesBancarioRubro? bancoMovimientoTipo.interesBancarioRubro.nombre.trim() : null;
        state.gastoBancarioRN = (/true/i).test(bancoMovimientoTipo.gastoBancarioRN);
        state.inversionRN = (/true/i).test(bancoMovimientoTipo.inversionRN);
        state.restringido = (/true/i).test(bancoMovimientoTipo.restringido);
        state.rowVersion = bancoMovimientoTipo.rowVersion;
    },
    'SET_CUENTA'(state, cuenta) {
        state.cuenta = cuenta;
        state.cuentaId = (cuenta) ? cuenta.id : 0;
        state.cuentaNombre = (cuenta) ? cuenta.nombre.trim() : null;
    },
    'SET_RUBRO'(state, rubro) {
        state.rubro = rubro;
        state.rubroId = (rubro) ? rubro.id : 0;
        state.rubroNombre = (rubro) ? rubro.nombre.trim() : null;
    },
    'SET_SUBRUBRO'(state, subrubro) {
        state.subrubro = subrubro;
        state.subrubroId = (subrubro) ? subrubro.id : 0;
        state.subrubroNombre = (subrubro) ? subrubro.nombre.trim() : null;
    },
    'SET_CUENTA_INGRESOS_GASTOS'(state, cuentaIngresosGastos) {
        state.cuentaIngresosGastos = cuentaIngresosGastos;
        if (cuentaIngresosGastos) {
            state.cuentaIngresosGastosId = cuentaIngresosGastos.id? cuentaIngresosGastos.id : 0; 
            state.cuentaIngresosGastosNombre = cuentaIngresosGastos.nombre? cuentaIngresosGastos.nombre.trim() : null;
        } else {
            state.cuentaIngresosGastosId = 0;
            state.cuentaIngresosGastosNombre = null;
        }
    },
    'SET_INTERES_BANCARIO_RUBRO'(state, interesBancarioRubro) {
        state.interesBancarioRubro = interesBancarioRubro;
        if (interesBancarioRubro) {
            state.interesBancarioRubroId = interesBancarioRubro.id? interesBancarioRubro.id : 0; 
            state.interesBancarioRubroNombre = interesBancarioRubro.nombre? interesBancarioRubro.nombre.trim() : null;
        } else {
            state.interesBancarioRubroId = 0;
            state.interesBancarioRubroNombre = null;
        }
    },

    'INICIALIZAR_BANCO_MOVIMIENTO_TIPO_DATOS' (state) {
        state.bancoMovimientoTipoDatos = [];
    },
    'SET_BANCO_MOVIMIENTO_TIPO_DATOS' (state, params) {
        state.bancoMovimientoTipoDatos = params.bancoMovimientoTipoDatos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, bancoMovimientoTipoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_MOVIMIENTO_TIPO', bancoMovimientoTipoId);

            if (bancoMovimientoTipoId != 0) {
                apiAxios.get('bancosmovimientostipos/' + bancoMovimientoTipoId + '/abm' ) 
                    .then(res => {
                        commit('SET_BANCO_MOVIMIENTO_TIPO', res.data);
                        resolve();
                    })
                    .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let bancoMovimientoTipo = {
                nombre: state.nombre.toUpperCase().trim(), 
                abreviacion: state.abreviacion.toUpperCase().trim(),
                credito: state.credito,
                requiereNumero: state.requiereNumero,
                cuentaId: state.cuentaId, 
                rubroId: state.rubroId, 
                subrubroId: state.subrubroId, 
                cuentaIngresosGastosId: state.cuentaIngresosGastosId,
                interesBancarioRubroId: state.interesBancarioRubroId,
                gastoBancarioRN: (/true/i).test(state.gastoBancarioRN),
                inversionRN: (/true/i).test(state.inversionRN)
            }

            let url = 'bancosmovimientostipos';
            if (state.id != 0) {
                bancoMovimientoTipo.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, bancoMovimientoTipo)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setCuenta: ({commit}, cuenta) => {
        commit('SET_CUENTA', cuenta);
    },
    setRubro: ({commit}, rubro) => {
        commit('SET_RUBRO', rubro);
    },
    setSubrubro: ({commit}, subrubro) => {
        commit('SET_SUBRUBRO', subrubro);
    },
    setCuentaIngresosGastos: ({commit}, cuentaIngresosGastos) => {
        commit('SET_CUENTA_INGRESOS_GASTOS', cuentaIngresosGastos);
    },
    setInteresBancarioRubro: ({commit}, interesBancarioRubro) => {
        commit('SET_INTERES_BANCARIO_RUBRO', interesBancarioRubro);
    },

    getBancoMovimientoTipoDatos ( { commit }, bancoMovimientoTipoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCO_MOVIMIENTO_TIPO_DATOS');

            if (bancoMovimientoTipoId != 0) {
                apiAxios.get('bancosmovimientostipos/' + bancoMovimientoTipoId ) 
                .then(res => {
                    let bancoMovimientoTipoDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'abreviacion', 'campo': 'Abreviacion', 'valor': res.data.abreviacion, 'formato': '' },
                        { 'nombre': 'credito', 'campo': 'Crédito', 'valor': res.data.credito ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'requiereNumero', 'campo': 'Req. Numero', 'valor': (res.data.requiereNumero) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'cuenta', 'campo': 'Cuenta', 'valor': res.data.cuenta, 'formato': '' },
                        { 'nombre': 'cuentaIngresosGastos', 'campo': 'Cuenta Ingresos/Gastos', 'valor': res.data.cuentaIngresosGastos, 'formato': '' },
                        { 'nombre': 'interesBancarioRubro', 'campo': 'Rubro de Intereses', 'valor': res.data.interesBancarioRubro, 'formato': '' },
                        { 'nombre': 'gastoBancarioRN', 'campo': 'Gasto Bco Incluido en RN', 'valor': (res.data.gastoBancarioRN) ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'inversionRN', 'campo': 'Movimiento Incluido como Inversion en RN', 'valor': (res.data.inversionRN) ? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        bancoMovimientoTipoDatos 
                    }
                    commit('SET_BANCO_MOVIMIENTO_TIPO_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}